<template>
  <div>
    <div
      v-if="
        typeof error_messages === 'object' &&
          Object.keys(error_messages).length > 0
      "
      class="alert alert-danger"
    >
      <ul>
        <template v-for="(error, i) in error_messages">
          <span v-bind:key="i">
            <li v-for="(message, ii) in error" v-bind:key="ii">
              {{ message }}
            </li>
          </span>
        </template>
      </ul>
    </div>
    <div class="tabs">
      <v-tabs
        v-model="tab"
        background-color="light primary"
        class="elevation-2"
        dark
      >
        <v-tab>{{ $t("MATERIAL") }}</v-tab>
        <v-tab v-if="isEdit">{{ $t("REQUIREMENTS_TO_MATERIALS") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat class="my-card-fw">
            <v-card-text>
              <vue-form-generator
                ref="form"
                :schema="materialSchema"
                :model="material"
                :options="formOptions"
              ></vue-form-generator>
              <br />
              <v-btn
                @click="save()"
                class="btn btn-success btn-elevate kt-login__btn-primary text-white"
                >{{ $t("SAVE") }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item v-if="isEdit" class="pt-2">
          <v-btn
            @click="addDetail()"
            class="btn btn-success btn-elevate kt-login__btn-primary text-white"
            >{{ $t("ADD_REQUIREMENT") }}
          </v-btn>

          <div v-if="addNew">
            <v-row class="mx-2">
              <v-col cols="5">
                {{ $t("TYPE_OF_REQUIREMENT") }}:
                <vu-select
                  append-to-body
                  :options="materialProperties"
                  label="name"
                  v-model="property"
                  @input="property_values = []"
                ></vu-select>
              </v-col>
              <v-col cols="5">
                {{ $t("VALUES") }}:
                <vu-select
                  append-to-body
                  v-if="property != null"
                  :options="property.values"
                  label="name"
                  v-model="property_values"
                ></vu-select>
              </v-col>

              <v-col cols="2">
                <br />
                <v-btn
                  @click="saveDetail()"
                  class="btn btn-success btn-block btn-elevate kt-login__btn-primary text-white"
                  >{{ $t("ADD") }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <hr />

          <template v-if="isLoadingMaterials == false">
            <v-row
              class="mx-2 border-bottom"
              v-for="detail of material.details"
              v-bind:key="detail.id"
            >
              <v-col cols="5">
                {{ $t("REQUIREMENT") }}:
                <input
                  type="text"
                  class="form-control"
                  :value="
                    detail.propertyName +
                      (detail.isArchived ? ' (' + $t('ARCHIVED') + ')' : '')
                  "
                  disabled
                />
              </v-col>
              <v-col cols="5">
                {{ $t("VALUE") }}:
                <input
                  type="text"
                  class="form-control"
                  :value="
                    detail.valueName +
                      (detail.isArchived ? ' (' + $t('ARCHIVED') + ')' : '')
                  "
                  disabled
                />
              </v-col>

              <v-col cols="2">
                <br />
                <v-btn
                  @click="deleteProperty(detail)"
                  class="btn btn-danger btn-block btn-elevate kt-login__btn-primary text-white"
                  >{{ $t("DELETE") }}</v-btn
                >
              </v-col>
            </v-row>
            <br />
            <v-btn
              @click="save()"
              class="btn btn-success btn-elevate kt-login__btn-primary text-white"
              >{{ $t("SAVE") }}
            </v-btn>
          </template>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css"; // optional full css additions

import {
  GET_MATERIAL,
  SAVE_MATERIAL,
  UPDATE_MATERIAL
} from "@/store/materials.module";

import { GET_DATA } from "@/store/formselect.module";

import { GET_MATERIALPROPERTIES } from "@/store/materialProperties.module";

import { GET_CLIENTS } from "@/store/clients.module";

import { mapGetters, mapState } from "vuex";
// Vue.use(VueFormGenerator)

import _ from "lodash";

export default {
  name: "createUpdate",

  components: {
    "vue-form-generator": VueFormGenerator.component
  },
  computed: {
    ...mapGetters(["isLoadingMaterials"]),
    ...mapState({
      errors: state => state.auth.errors
    }),
    isEdit: function() {
      if (typeof this.$route.params.id !== "undefined") {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      error_messages: [],
      addNew: false,
      model: "materials",
      tab: 0,
      material: {
        name: null,
        details: []
      },
      materialTypes: {},
      manufactureTypes: [],
      materialProperties: [],
      materialSchema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("NAME"),
            model: "name",
            required: true,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!",
              textTooSmall: this.$t("THE_FIELD_MUST_BE_AT_LEAST") + " {0} " + this.$t("CHARACTERS") + " !!!"
            })
          }
        ]
      },
      requirementSchema: {
        fields: [{}]
      },
      requirements: {},
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false,
        validateAsync: true
      },
      property: {
        values: []
      },
      property_values: []
    };
  },
  mounted() {
    let vm = this;

    _.delay(function() {
      var current_page = vm.$t("ADD");
      if (typeof vm.$route.params.id !== "undefined") {
        current_page = vm.$t("MODIFY");
      }
      vm.$store.dispatch(SET_BREADCRUMB, [
        { title: this.$t("MATERIALS"), route: "/materials" },
        { title: current_page }
      ]);
    }, 300);
    this.getMaterialTypes();
    this.getMaterialProperties();
    this.getManufactureTypes()
  },
  methods: {
    deleteProperty: function(detail) {
      let vm = this;
      vm.$confirm({
        title: this.$t("DELETE_CONFIRMATION"),
        content: this.$t("DELETE_CONFIRMATION_DESCRIPTION"),
        icon: "warning",
        okText: this.$t("OK_TEXT"),
        cancelText: this.$t("CANCEL_TEXT"),
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        onOk() {
          vm.material.details = _.remove(vm.material.details, function(n) {
            return n !== detail;
          });
        },
        onCancel() {}
      });
    },
    setPropertyValues: function(detail) {
      let options = _.find(this.materialProperties, { id: detail.propertyId });
      if (typeof options !== "undefined") {
        return options.values;
      }

      return [];
    },
    saveDetail: function() {
      let vm = this;

      if (!vm.property.id || !vm.property_values.id) {
        return;
      }

      vm.material.details.push({
        propertyName: vm.property.name,
        propertyId: vm.property.id,
        valueId: vm.property_values.id,
        valueName: vm.property_values.name
      });

      vm.addNew = false;
      vm.property_values = [];
      vm.property = {
        values: []
      };
    },
    getMaterialProperties: function() {
      let vm = this;
      this.error_messages = [];
      this.$store
        .dispatch(GET_MATERIALPROPERTIES)
        .then(data => {
          vm.$nextTick(function() {
            vm.materialProperties = data.data;
          });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });
        });
    },
    addDetail: function() {
      let vm = this;

      vm.addNew = true;
      this.error_messages = [];
      this.$store
        .dispatch(GET_MATERIALPROPERTIES)
        .then(data => {
          vm.$nextTick(function() {
            vm.materialProperties = data.data;

            let addMaterialDetail = {
              type: "select",
              label: this.$t("REQUIREMENT"),
              model: "property",
              selectOptions: { noneSelectedText: this.$t("CHOOSE") },
              values: vm.materialProperties,
              styleClasses: "col-md-6",
              onChanged: function(model, newVal) {
                vm.addRequirement(newVal);
              }
            };

            vm.requirementSchema.fields.push(addMaterialDetail);
          });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });
        });
    },
    getMaterialTypes: function() {
      let vm = this;

      let payload = {
        materialTypes: {
          fields: ["id", "name"],
          search: ""
        }
      };
      this.error_messages = [];
      this.$store
        .dispatch(GET_DATA, payload)
        .then(data => {
          vm.$nextTick(function() {
            vm.materialTypes = data.data.materialTypes;

            let addTypeId = {
              type: "select",
              label: this.$t("MATERIAL_TYPE"),
              model: "typeId",
              required: true,
              selectOptions: { noneSelectedText: this.$t("CHOOSE") },
              hideNoneSelectedText: true,
              values: vm.materialTypes,
              validator: VueFormGenerator.validators.required.locale({
                fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
              })
            };

            vm.materialSchema.fields.push(addTypeId);

            if (typeof this.$route.params.id !== "undefined") {
              vm.getData().then(() => {
                vm.getClients();
              });
            } else {
              vm.getClients();
            }
          });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });
        });
    },
    getManufactureTypes: function() {
      let vm = this;

      let payload = {
        manufactureTypes: {
          fields: ["id", "name"],
          search: ""
        }
      };
      this.error_messages = [];
      this.$store
          .dispatch(GET_DATA, payload)
          .then(data => {
            vm.$nextTick(function() {
              vm.manufactureTypes = _.orderBy(data.data.manufactureTypes, "name");
              vm.manufactureTypes = _.uniqBy(vm.manufactureTypes, "id");

              let manufactureTypeField = {
                type: "select",
                inputType: "text",
                label: this.$t("MANUFACTURE_TYPES"),
                model: "manufactureTypeId",
                required: true,
                selectOptions: { noneSelectedText: this.$t("CHOOSE") },
                values: vm.manufactureTypes,
                validator: VueFormGenerator.validators.required.locale({
                  fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
                })
              };

              vm.materialSchema.fields.push(manufactureTypeField);
            });
          })
          .catch(response => {
            vm.error_messages = response.data.errors;
            vm.$scrollTo("html", 420, {
              offset: -300
            });
          });
    },
    async save() {
      let vm = this;

      vm.error_messages = [];

      let errors = await this.$refs.form.validate();

      if (errors.length) {
        return;
      }

      var action =
        typeof this.$route.params.id !== "undefined"
          ? UPDATE_MATERIAL
          : SAVE_MATERIAL;

      vm.$store
        .dispatch(action, { payload: vm.material })
        .then(data => {
          vm.$notification["success"]({
            message: data.status,
            description: data.message
          });

          vm.$router.push({ name: "materialsList" });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });

          if (response.status === 404) {
            vm.$notification["success"]({
              message: response.status,
              description: response.message
            });
            vm.$router.push({ name: "materialsList" });
          }
        });
    },
    getData: function() {
      let vm = this;

      let id = this.$route.params.id;
      this.error_messages = [];
      return this.$store
        .dispatch(GET_MATERIAL, id)
        .then(data => {
          vm.$nextTick(function() {
            vm.material = { ...data.data };
          });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });

          if (typeof response === "undefined" || response.status === 404) {
            vm.$notification["error"]({
              message: this.$t("ERROR") + " 404",
              description: this.$t("PAGE_NOT_FOUND")
            });
            vm.$router.push({ name: "materialsList" });
          }
        });
    },
    getClients: function() {
      let vm = this;

      // let id = this.$route.params.id;
      this.error_messages = [];
      this.$store
        .dispatch(GET_CLIENTS)
        .then(data => {
          vm.$nextTick(function() {
            vm.clients = data.data;

            if (
              typeof this.$route.params.id !== "undefined" &&
              vm.material.clientIsArchived
            ) {
              vm.clients.push({
                id: vm.material.clientId,
                name: vm.material.clientName + " (" + this.$t("ARCHIVED") + ")"
              });

              vm.clients = _.uniqBy(vm.clients, "id");
            }

            let clientId = {
              type: "select",
              inputType: "text",
              label: this.$t("CLIENT"),
              model: "clientId",
              selectOptions: { noneSelectedText: this.$t("CHOOSE") },
              values: vm.clients,
              required: true,
              validator: VueFormGenerator.validators.required.locale({
                fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
              })
            };

            let note = {
              type: "textArea",
              label: this.$t("REMARK") + " (BG)",
              model: "note"
            };

            let noteEn = {
              type: "textArea",
              label: this.$t("REMARK") + " (EN)",
              model: "note_en"
            };

            vm.materialSchema.fields.push(clientId);
            vm.materialSchema.fields.push(note);
            vm.materialSchema.fields.push(noteEn);
          });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });
        });
    }
  }
};
</script>
